import { RESIZE_OBSERVER_SUPPORTED } from "./armor-system-3KQ5PVRN.js";
import { getWindow } from "./armor-system-4JVSZEDO.js";

// src/hooks/useResizeObserver.ts
import { useCallback, useEffect } from "react";
import { throttle } from "throttle-debounce";
var win = getWindow();
var useResizeObserver = function useResizeObserver(enabled, onHeightChange, onWidthChange) {
  var _ref = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
    enableInitialCall = _ref.enableInitialCall,
    throttleDelay = _ref.throttleDelay,
    containerRef = _ref.containerRef;
  var onChangeInternal = useCallback(function () {
    if (onHeightChange) {
      var height = 0;
      if (containerRef && containerRef.current) {
        height = containerRef.current.getBoundingClientRect().height;
      } else if (win) {
        height = win.innerHeight;
      }
      onHeightChange(height);
    }
  }, [onHeightChange, containerRef]);
  var onChangeInternalDecorated = useCallback(throttle(throttleDelay || 0, false, onChangeInternal), [onChangeInternal, throttleDelay]);
  useEffect(function () {
    var validContainer = containerRef && containerRef.current;
    var observer = enabled && validContainer && RESIZE_OBSERVER_SUPPORTED ?
    // @ts-ignore
    new ResizeObserver(function () {
      return onChangeInternalDecorated();
    }) : null;
    if (enabled) {
      if (enableInitialCall) {
        onChangeInternal();
      }
      if (observer && (containerRef == null ? void 0 : containerRef.current)) {
        observer.observe(containerRef.current);
      } else if (win) {
        win.addEventListener("resize", onChangeInternalDecorated);
      }
    }
    return function () {
      if (enabled) {
        if (win) {
          win.removeEventListener("resize", onChangeInternalDecorated);
        }
        if (observer) {
          observer.disconnect();
        }
      }
    };
  }, [enabled, onChangeInternalDecorated, enableInitialCall, containerRef, onChangeInternal]);
};
export { useResizeObserver };